export default "__VITE_ASSET__0ab4f839__"